/**
 * Create store system routing-ospf
 *
 * @since 2018-07-09
 * @author jongsung.Lee(devp010)
 */

import {SystemApiPrefix as smApiPrefix} from 'utils'
import compareObject from '~/utils/compare'

export const plugins = [Plugin]

export const state = () => ({
  // axios api's urls
  apiUrlPath: {
    ospfConfig: `${smApiPrefix}/ospf/config`, //                            config
    ospfStatus: `${smApiPrefix}/ospf/config/status`, //                     status
    ospfNeighborStatus: `${smApiPrefix}/ospf/config/status-neighbor`, //    status-neighbor
    ospfInterfaceStatus: `${smApiPrefix}/ospf/config/status-interface`, //  status-interface
    ospfDatabaseStatus: `${smApiPrefix}/ospf/config/status-database`, //    status-database
    ospfAdvance: `${smApiPrefix}/ospf/config/advance`, //                   advance
    ripIfsCandis: `${smApiPrefix}/rip/config/interface-candidates`, //      route_map interface candidates
    ospfAreas: `${smApiPrefix}/ospf/config/areas`, //                       area
    ospfNetworks: `${smApiPrefix}/ospf/config/networks`, //                 network list
    ospfIfsCandidates: `${smApiPrefix}/ospf/config/interface-candidates`, // interface candidates
    ospfInterfaces: `${smApiPrefix}/ospf/config/interfaces`, //             interface
    ospfApply: `${smApiPrefix}/ospf/config/apply`,
    ospfCancel: `${smApiPrefix}/ospf/config/cancel`
  },
  // copyData for editing.
  selectedItem: {},
  // areaType
  ospfAreaAuthType: [{id: 0, value: 'None'}, {id: 1, value: 'Text'}, {id: 2, value: 'MD5'}],
  ospfAreaType: [{id: 1, value: 'Regula'}, {id: 2, value: 'Stub'}, {id: 3, value: 'Virtual-Link'}],
  // ospf config
  ospfConfig: {
    enable: 0, //           enable required (one of 0, 1)
    router_id: '0.0.0.0' // Router ID required (string) (IPv4 Address)
  },
  ospfConfigClone: {
    enable: 0, //           enable required (one of 0, 1)
    router_id: '0.0.0.0' // Router ID required (string) (IPv4 Address)
  },
  // ospf status
  ospfStatus: {status: ''},
  ospfNeighborStatus: {status: ''}, //  neighbor
  ospfInterfaceStatus: {status: ''}, // interface
  ospfDatabaseStatus: {status: ''}, //  database
  // ospf advacne
  ospfAdvance: {
    distance: 120, //             Distance (integer - default: 110 - minimum: 1 - maximum: 255)
    default_info: 0, //          Default Information(None: 0, Originate: 1, Always: 2)
    redist_static_enable: 0, //   (OFF: 0, ON: 1)
    redist_rip_enable: 0, //      (OFF: 0, ON: 1)
    redist_bgp_enable: 0, //      (OFF: 0, ON: 1)
    rout_map_enable: 0, //        (OFF: 0, ON: 1)
    rout_map_sync_interval: 5, // (integer - default: 5 - minimum: 1 - maximum: 60)
    rout_map: [] //               id, rout_addr, rout_mask, metric, ifc_id, ifc_name, order
  },
  // rout_mask(integer - minimum: 0 - maximum: 31)
  rout_mapInfo: {id: '', rout_addr: null, rout_mask: 0, metric: 0, ifc_id: '', ifc_name: '', order: 1},
  ripIfsCandidateList: [],
  ospfArea: {
    id: 0,
    area: '', //  IP or number (minimum: 0 - maximum: 4294967295)
    auth: 0, //   (None: 0, Text: 1, MD5: 2)
    type: 1, //   (Regular: 1, Stub: 2, Virtual-Link: 3)
    peer_ip_addr: null // Peer IP address
  },
  ospfAreaList: [],
  ospfAreaSelectList: [],
  ospfNetwork: {id: 0, network_addr: '', network_mask: 0, ospf_area_id: '', ospf_area_name: ''},
  ospfNetworkList: [],
  ospfIfsCandidateList: [],
  ospfIfTypeSelectList: [{label: 'Broadcast', value: 1}, {label: 'Point-to-Point', value: 2}],
  ospfIfAuthSelectList: [{label: 'None', value: 0}, {label: 'Text', value: 1}, {label: 'MD5', value: 2}],
  ospfInterface: {
    id: '',
    ifc_id: '',
    ifc_name: '',
    type: 1, //         (Broadcast: 1, Point-to-Point: 2)
    priority: 1, //     (integer - default: 1 - minimum: 0 - maximum: 255)
    cost: 1, //         (integer - default: 1 - minimum: 1 - maximum: 65535)
    auth_type: 0, //    (None: 0, Text: 1, MD5: 2)
    auth_passwd: '', // auth_type: Text
    auth_id: 1, //      MD5 - (integer - minimum: 1 - maximum: 255)
    auth_key: '', //    MD5 - (string - maxLength: 16)
    timer_hello: 10, // (integer - default: 10 - minimum: 1 - maximum: 65535)
    timer_dead: 40, //      (integer - default: 40 - minimum: 1 - maximum: 65535)
    timer_retransmit: 5, // (integer - default: 5 - minimum: 3 - maximum: 65535)
    timer_transmit: 1 //    (integer - default: 5 - minimum: 1 - maximum: 65535)
  },
  ospfInterfacesList: []
})

export const mutations = {
  resetSelectedItem (state) {
    state.selectedItem = {}
  },
  setSelectedItem (state, item) {
    state.selectedItem = item
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> config
  resetOspfConfig (state) {
    state.ospfConfig.enable = 0
    state.ospfConfig.router_id = '0.0.0.0'
  },
  setOspfConfig (state, item) {
    state.ospfConfig.enable = item.enable
    state.ospfConfig.router_id = item.router_id
    // clone
    state.ospfConfigClone.enable = _.cloneDeep(item.enable)
    state.ospfConfigClone.router_id = _.cloneDeep(item.router_id)
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> status
  resetOspfStatus (state) {
    state.ospfStatus.status = ''
  },
  setOspfStatus (state, item) {
    state.ospfStatus.status = item.status
  },
  resetOspfNeighborStatus (state) {
    state.ospfNeighborStatus.status = ''
  },
  setOspfNeighborStatus (state, item) {
    state.ospfNeighborStatus.status = item.status
  },
  resetOspfInterfaceStatus (state) {
    state.ospfInterfaceStatus.status = ''
  },
  setOspfInterfaceStatus (state, item) {
    state.ospfInterfaceStatus.status = item.status
  },
  resetOspfDatabaseStatus (state) {
    state.ospfDatabaseStatus.status = ''
  },
  setOspfDatabaseStatus (state, item) {
    state.ospfDatabaseStatus.status = item.status
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> advance
  resetOspfAdvance (state) {
    state.ospfAdvance.distance = 120
    state.ospfAdvance.default_info = 30
    state.ospfAdvance.redist_static_enable = 0
    state.ospfAdvance.redist_rip_enable = 0
    state.ospfAdvance.redist_bgp_enable = 0
    state.ospfAdvance.rout_map_enable = 0
    state.ospfAdvance.rout_map_sync_interval = 5
    state.ospfAdvance.rout_map = []
  },
  setOspfAdvance (state, item) {
    state.ospfAdvance.distance = item.distance
    state.ospfAdvance.default_info = item.default_info
    state.ospfAdvance.redist_static_enable = item.redist_static_enable
    state.ospfAdvance.redist_rip_enable = item.redist_rip_enable
    state.ospfAdvance.redist_bgp_enable = item.redist_bgp_enable
    state.ospfAdvance.rout_map_enable = item.rout_map_enable
    state.ospfAdvance.rout_map_sync_interval = item.rout_map_sync_interval
    if (item.rout_map !== null && item.rout_map.length > 0) {
      for (const rmap of item.rout_map) {
        rmap.id = `${_.random(100, 10000)}_${rmap.rout_addr}`
      }
      state.ospfAdvance.rout_map = item.rout_map
    } else {
      state.ospfAdvance.rout_map = []
    }
  },
  moveUpRoutMapByOrder (state, item) {
    // change order the item
    state.ospfAdvance.rout_map.splice(item.itemIndex, 1)
    state.ospfAdvance.rout_map.splice(item.itemIndex - 1, 0, item)
    let iIdx = 0
    // reset order & itemIndex  properties
    for (const rmap of state.ospfAdvance.rout_map) {
      rmap.itemIndex = iIdx++
      rmap.order = iIdx
    }
  },
  moveDownRoutMapByOrder (state, item) {
    // change order the item
    state.ospfAdvance.rout_map.splice(item.itemIndex, 1)
    state.ospfAdvance.rout_map.splice(item.itemIndex + 1, 0, item)
    let iIdx = 0
    for (const rmap of state.ospfAdvance.rout_map) {
      rmap.itemIndex = iIdx++
      rmap.order = iIdx
    }
  },
  resetRipInterfaceCandidates (state) {
    state.ripIfsCandidateList = []
  },
  setRipInterfaceCandidates (state, data) {
    if (data !== undefined && data.length > 0) {
      for (const ifs of data) {
        state.ripIfsCandidateList.push(
          {
            label: ifs.name,
            value: ifs.id
          }
        )
      }
    }
  },
  // routmap dialog
  clearOspfRoutMapDialog (state) {
    state.rout_mapInfo.id = ''
    state.rout_mapInfo.rout_addr = null
    state.rout_mapInfo.rout_mask = 0
    state.rout_mapInfo.metric = 0
    state.rout_mapInfo.ifc_id = ''
    state.rout_mapInfo.ifc_name = ''
    state.rout_mapInfo.order = 1
  },
  setOspfRoutMapDialog (state, item) {
    state.rout_mapInfo.id = item.id
    state.rout_mapInfo.rout_addr = item.rout_addr
    state.rout_mapInfo.rout_mask = item.rout_mask
    state.rout_mapInfo.metric = item.metric
    state.rout_mapInfo.ifc_id = item.ifc_id
    state.rout_mapInfo.ifc_name = item.ifc_name
    state.rout_mapInfo.order = item.order
  },
  // routmap CRUD
  resetOspfRoutMapList (state) {
    state.ospfAdvance.rout_map = []
  },
  setOspfRoutMapList (state, data) {
    if (data !== undefined) {
      state.ospfAdvance.rout_map = data
    }
  },
  addOspfRoutMapList (state, item) {
    state.ospfAdvance.rout_map.push(item)
  },
  editOspfRoutMapList (state, item) {
    const findRslt = _.find(state.ospfAdvance.rout_map, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.ospfAdvance.rout_map.splice(_.findIndex(state.ospfAdvance.rout_map, state.selectedItem.item), 1, item)
    }
  },
  delOspfRoutMapList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.ospfAdvance.rout_map.splice(item.itemIndex, 1)
      }
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> area
  clearOspfArea (state) {
    state.ospfArea.id = 0
    state.ospfArea.area = null
    state.ospfArea.auth = 0
    state.ospfArea.type = 1
    state.ospfArea.peer_ip_addr = null
  },
  setOspfArea (state, item) {
    state.ospfArea.id = item.id
    state.ospfArea.area = item.area
    state.ospfArea.auth = item.auth
    state.ospfArea.type = item.type
    state.ospfArea.peer_ip_addr = item.peer_ip_addr
  },
  resetOspfAreaList (state) {
    state.ospfAreaList = []
  },
  setOspfAreaList (state, data) {
    state.ospfAreaList = data
  },
  resetOspfAreaSelectList (state) {
    state.ospfAreaSelectList = []
  },
  setOspfAreaSelectList (state, data) {
    for (const area of data) {
      state.ospfAreaSelectList.push(
        {
          label: area.area,
          value: area.id
        }
      )
    }
  },
  addOspfAreaList (state, item) {
    if (item !== undefined) {
      state.ospfAreaList.push(item)
    }
  },
  delOspfAreaList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.ospfAreaList.splice(item.itemIndex, 1)
      }
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> network
  clearOspfNetwork (state) {
    state.ospfNetwork.id = 0
    state.ospfNetwork.network_addr = null
    state.ospfNetwork.network_mask = 0
    state.ospfNetwork.ospf_area_id = ''
    state.ospfNetwork.ospf_area_name = ''
  },
  setOspfNetwork (state, item) {
    state.ospfNetwork.id = item.id
    state.ospfNetwork.network_addr = item.network_addr
    state.ospfNetwork.network_mask = item.network_mask
    state.ospfNetwork.ospf_area_id = item.ospf_area_id
    state.ospfNetwork.ospf_area_name = item.ospf_area_name
  },
  resetOspfNetworkList (state) {
    state.osfpNetworkList = []
  },
  setOspfNetworkList (state, data) {
    state.ospfNetworkList = data
  },
  addOspfNetworkList (state, item) {
    if (item !== undefined) {
      state.ospfNetworkList.push(item)
    }
  },
  editOspfNetworkList (state, item) {
    const findRslt = _.find(state.ospfNetworkList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.ospfNetworkList.splice(_.findIndex(state.ospfNetworkList, state.selectedItem), 1, item)
    }
  },
  delOspfNetworkList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.ospfNetworkList.splice(item.itemIndex, 1)
      }
    }
  },
  clearOspfInterface (state) {
    state.ospfInterface.id = ''
    state.ospfInterface.ifc_id = ''
    state.ospfInterface.ifc_name = ''
    state.ospfInterface.type = 1
    state.ospfInterface.priority = 1
    state.ospfInterface.cost = 1
    state.ospfInterface.auth_type = 0
    state.ospfInterface.auth_passwd = ''
    state.ospfInterface.auth_id = ''
    state.ospfInterface.auth_key = ''
    state.ospfInterface.timer_hello = 10
    state.ospfInterface.timer_dead = 40
    state.ospfInterface.timer_retransmit = 5
    state.ospfInterface.timer_transmit = 1
  },
  setOspfInterface (state, item) {
    state.ospfInterface.id = item.id
    state.ospfInterface.ifc_id = item.ifc_id
    state.ospfInterface.ifc_name = item.ifc_name
    state.ospfInterface.type = item.type
    state.ospfInterface.priority = item.priority
    state.ospfInterface.cost = item.cost
    state.ospfInterface.auth_type = item.auth_type
    // not get
    state.ospfInterface.auth_passwd = '' // item.auth_passwd
    state.ospfInterface.auth_id = item.auth_id
    state.ospfInterface.auth_key = item.auth_key
    state.ospfInterface.timer_hello = item.timer_hello
    state.ospfInterface.timer_dead = item.timer_dead
    state.ospfInterface.timer_retransmit = item.timer_retransmit
    state.ospfInterface.timer_transmit = item.timer_transmit
  },
  resetOspfInterfaceCandidates (state) {
    state.ospfIfsCandidateList = []
  },
  setOspfInterfaceCandidates (state, data) {
    if (data !== undefined && data.length > 0) {
      for (const ifs of data) {
        state.ospfIfsCandidateList.push(
          {
            label: ifs.name,
            value: ifs.id
          }
        )
      }
    }
  },
  resetOspfInterfaceList (state) {
    state.ospfInterfacesList = []
  },
  setOspfInterfaceList (state, data) {
    state.ospfInterfacesList = data
  },
  addOspfInterfaceList (state, item) {
    if (item !== undefined) {
      state.ospfInterfacesList.push(item)
    }
  },
  editOspfInterfaceList (state, item) {
    const findRslt = _.find(state.ospfInterfacesList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.ospfInterfacesList.splice(_.findIndex(state.ospfInterfacesList, state.selectedItem), 1, item)
    }
  },
  delOspfInterfaceList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.ospfInterfacesList.splice(item.itemIndex, 1)
      }
    }
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> config
  async getOspfConfig ({commit, state}, loadingOpt) {
    commit('resetOspfConfig')
    const apiUrl = state.apiUrlPath['ospfConfig']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfConfig', result)
      return true
    } else {
      return false
    }
  },
  async editOspfConfig ({commit, state}, loadingOpt) {
    const apiUrl = state.apiUrlPath['ospfConfig']
    const rslt = await this.$axios.$put(apiUrl, state.ospfConfig, loadingOpt)
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('setOspfConfig', rslt.result)
      return true
    } else {
      return false
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> status
  async getOspfStatus ({commit, state}) {
    commit('resetOspfStatus')
    const apiUrl = state.apiUrlPath['ospfStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfStatus', result)
      return true
    } else {
      return false
    }
  },
  async getOspfNeighborStatus ({commit, state}) {
    commit('resetOspfNeighborStatus')
    const apiUrl = state.apiUrlPath['ospfNeighborStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfNeighborStatus', result)
      return true
    } else {
      return false
    }
  },
  async getOspfInterfaceStatus ({commit, state}) {
    commit('resetOspfInterfaceStatus')
    const apiUrl = state.apiUrlPath['ospfInterfaceStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfInterfaceStatus', result)
      return true
    } else {
      return false
    }
  },
  async getOspfDatabaseStatus ({commit, state}) {
    commit('resetOspfDatabaseStatus')
    const apiUrl = state.apiUrlPath['ospfDatabaseStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfDatabaseStatus', result)
      return true
    } else {
      return false
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> advance
  async getOspfAdvance ({commit, state}) {
    commit('resetOspfAdvance')
    const apiUrl = state.apiUrlPath['ospfAdvance']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfAdvance', result)
      return true
    } else {
      return false
    }
  },
  async editOspfAdvance ({commit, state}) {
    const putParam = _.cloneDeep(state.ospfAdvance)
    if (putParam.rout_map !== undefined && putParam.rout_map.length > 0) {
      let iIdx = 0
      for (const rmap of putParam.rout_map) {
        delete rmap.id
        rmap.itemIndex = iIdx++
        rmap.order = iIdx
      }
    }
    const apiUrl = state.apiUrlPath['ospfAdvance']
    const {code, result} = await this.$axios.$put(apiUrl, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfAdvance', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  // rout_map
  async getRipInterfaceCandidates ({commit, state}) {
    commit('resetRipInterfaceCandidates')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['ripIfsCandis'])
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRipInterfaceCandidates', result)
      return true
    } else {
      return false
    }
  },
  async addOspfRoutMapList ({commit, state}) {
    const addParam = _.cloneDeep(state.rout_mapInfo)
    // make id
    addParam.id = `${_.random(100, 10000)}_${state.rout_mapInfo.rout_addr}`
    addParam.rout_mask = Number(addParam.rout_mask)
    commit('addOspfRoutMapList', addParam)
    return true
  },
  async editOspfRoutMapList ({commit, state}) {
    const putParam = _.cloneDeep(state.rout_mapInfo)
    putParam.rout_mask = Number(putParam.rout_mask)
    commit('editOspfRoutMapList', putParam)
    return true
  },
  async delOspfRoutMapList ({commit, state}, param) {
    commit('delOspfRoutMapList', param.itemIndexList)
    return true
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> area
  async getOspfAreaList ({commit, state}, loadingOpt) {
    commit('resetOspfAreaList')
    const apiUrl = state.apiUrlPath['ospfAreas']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfAreaList', result)
      return true
    } else {
      return false
    }
  },
  async getOspfAreaSelectList ({commit, state}, loadingOpt) {
    commit('resetOspfAreaSelectList')
    const apiUrl = state.apiUrlPath['ospfAreas']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfAreaSelectList', result)
      return true
    } else {
      return false
    }
  },
  async addOspfAreaList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ospfAreas']
    const addParam = {
      area: (state.ospfArea.area).toString(),
      auth: state.ospfArea.auth,
      type: state.ospfArea.type,
      peer_ip_addr: state.ospfArea.peer_ip_addr
    }
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addOspfAreaList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delOspfAreaList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['ospfAreas']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delOspfAreaList', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> network list
  async getOspfNetworkList ({commit, state}, loadingOpt) {
    commit('resetOspfNetworkList')
    const apiUrl = state.apiUrlPath['ospfNetworks']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfNetworkList', result)
      return true
    } else {
      return false
    }
  },
  async addOspfNetworkList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ospfNetworks']
    const addParam = {
      network_addr: state.ospfNetwork.network_addr,
      network_mask: Number(state.ospfNetwork.network_mask),
      ospf_area_id: state.ospfNetwork.ospf_area_id,
      ospf_area_name: state.ospfNetwork.ospf_area_name
    }
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addOspfNetworkList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async editOspfNetworkList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ospfNetworks']
    const putParam = {
      network_addr: state.ospfNetwork.network_addr,
      network_mask: Number(state.ospfNetwork.network_mask),
      ospf_area_id: state.ospfNetwork.ospf_area_id,
      ospf_area_name: state.ospfNetwork.ospf_area_name
    }
    const {code, result} = await this.$axios.$put(`${apiUrl}/${state.ospfNetwork.id}`, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editOspfNetworkList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delOspfNetworkList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['ospfNetworks']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delOspfNetworkList', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> interface list
  async getOspfInterfaceList ({commit, state}, loadingOpt) {
    commit('resetOspfInterfaceList')
    const apiUrl = state.apiUrlPath['ospfInterfaces']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfInterfaceList', result)
      return true
    } else {
      return false
    }
  },
  async getOspfInterfaceCandidates ({commit, state}) {
    commit('resetOspfInterfaceCandidates')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['ospfIfsCandidates'])
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfInterfaceCandidates', result)
      return true
    } else {
      return false
    }
  },
  async addOspfInterfaceList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ospfInterfaces']
    const addParam = _.cloneDeep(state.ospfInterface)
    delete addParam.id
    if (addParam.auth_type === 1) {
      // base64
      addParam.auth_passwd = btoa(addParam.auth_passwd)
    }
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addOspfInterfaceList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async editOspfInterfaceList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ospfInterfaces']
    const putParam = _.cloneDeep(state.ospfInterface)
    if (putParam.auth_type === 1) {
      if ((putParam.auth_passwd).length === 0) {
        delete putParam.auth_passwd
      } else {
        // base64 for password ( only modify password )
        putParam.auth_passwd = btoa(putParam.auth_passwd)
      }
    }
    const {code, result} = await this.$axios.$put(`${apiUrl}/${state.ospfInterface.id}`, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editOspfInterfaceList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delOspfInterfaceList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['ospfInterfaces']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delOspfInterfaceList', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> apply & cancel
  async setOspfApply ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['ospfApply'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  },
  async setOspfCancel ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['ospfCancel'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  }
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< Bgp apply & cancel
}

export const getters = {
  // ospf Config
  compareOspfConfigData (state) {
    return compareObject(state.ospfConfig, state.ospfConfigClone)
  }
}

export const strict = false
